exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\nsvg[data-v-636ce1e5] {\n  width: 100%;\n  height: 40pt;\n  border: 1px solid #999;\n  margin-top: 0.2em;\n  margin-bottom: 0.2em;\n  border-radius: 0.5em;\n}\n", ""]);

// exports
